/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, hasResponseData, getId, getOne, getProperty } = Response;

class Client {
    constructor(clientId) {
        this.requests = new Requests();
        this.clientId = clientId;
    }

    cancel = () => {
        this.requests.cancel();
    };

    get = async () => {
        const params = { size: 1 };

        if (this.clientId) {
            params.id = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get('/tenant', {
                cancelToken: this.requests.token(),
                params
            });
            if (!hasData(response)) {
                debug.e('No Client found');
                return false;
            }

            return getOne(response);
        } catch (e) {
            debug.e(e);
            return false;
        }
    };

    getLinkId = async (linkedTenantId) => {
        const params = { linkedTenantId };
        try {
            const response = await axios.get('/clientLink', {
                cancelToken: this.requests.token(),
                params
            });
            if (!hasData(response)) {
                debug.e('No Tenant Link found');
                return false;
            }

            return getId(response);
        } catch (e) {
            debug.e(e);
            return false;
        }
    };

    hasLogAccess = async () => {
        const params = {};

        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        try {
            const response = await axios.get(
                '/tenantSetting/security_logging',
                {
                    cancelToken: this.requests.token(),
                    params
                }
            );
            if (!hasResponseData(response)) {
                return false;
            }

            return getProperty(response, 'value');
        } catch (e) {
            debug.e('Unable to load Log Access Setting');
            return false;
        }
    };

    getClientCount = async ({
        count = true,
        excludeInternal = false,
        hidden = false,
        includePartner = false,
        includeTenant = true,
        includeUserCount = false,
        size = -1
    }) => {
        try {
            const response = await axios.get('/clientLink', {
                cancelToken: this.requests.token(),
                params: {
                    count,
                    excludeInternal,
                    hidden,
                    includePartner,
                    includeTenant,
                    includeUserCount,
                    size
                }
            });
            const parsed = parseInt(response?.data?.data?.count, 10);
            if (Number.isNaN(parsed)) {
                return 0;
            }
            return parsed;
        } catch (e) {
            debug.e('Unable to load Clients', e);
            return null;
        }
    };
}

export default Client;
